import { render, staticRenderFns } from "./CallUserList.vue?vue&type=template&id=595f91a5&scoped=true&"
import script from "./CallUserList.vue?vue&type=script&lang=ts&"
export * from "./CallUserList.vue?vue&type=script&lang=ts&"
import style0 from "./CallUserList.vue?vue&type=style&index=0&id=595f91a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595f91a5",
  null
  
)

export default component.exports